import { forwardRef } from "react";
import prepend from "ramda/src/prepend";

import { Select } from "../../UI/Select";
import { useTags } from "../../routes/super_admin/tags/hooks/useTags";

const notSetOption = { value: null, label: "not set" };

export const TagSelect = forwardRef((props, ref) => {
  const { tags } = useTags();

  const tagsOptions = tags.map((option) => ({ value: option.id, label: option.name }));

  return <Select {...props} ref={ref} isDisabled={!tags.length} options={prepend(notSetOption, tagsOptions)} />;
});
